<nb-card>
    <nb-card-header>{{ 'quotes.title' | translate }}</nb-card-header>
    <nb-card-body>
        <bst-quote-list [rows]="quotes" [showOrganisation]="false"></bst-quote-list>
    </nb-card-body>
</nb-card>
